import React from 'react'

export default function Loader() {
    return (
        <div className="defaultLoader">
           <span>Loading...</span>
        </div>
    )
}